import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { bool, string, elementType, func } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Button } from '@one-thd/sui-atomic-components';

export const ActionBarButton = ({
  text, ariaLabel, Icon, onClick, disabled, iconSize, componentButton, variant
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const clickFunction = disabled ? null : onClick;

  return (
    <Button
      component="span"
      variant={variant}
      aria-label={ariaLabel}
      startIcon={!isMobile ? Icon : null}
      onClick={clickFunction}
      disabled={disabled}
    >
      { !isMobile && text }
      { isMobile && (
        <Icon
          size="small"
        />
      ) }
    </Button>
  );
};

ActionBarButton.propTypes = {
  ariaLabel: string.isRequired,
  Icon: elementType,
  onClick: func.isRequired,
  componentButton: string,
  iconSize: string,
  disabled: bool,
  text: string,
  variant: string
};

ActionBarButton.defaultProps = {
  componentButton: 'span',
  iconSize: 'regular',
  Icon: null,
  disabled: false,
  text: '',
  variant: 'ghost'
};
